export interface EyeTestDataObject {
	baseSize: number,
	baseVisus: number       // Visus for 1m distance
}

export type EyeTestData = EyeTestDataObject[];

export const eyeTestData: EyeTestData = [
	// { baseSize: 589,    baseVisus: 0.01 },
	// { baseSize: 468,    baseVisus: 0.012 },
	// { baseSize: 372,    baseVisus: 0.016 },
	{ baseSize: 296, baseVisus: 0.02 },
	{ baseSize: 235, baseVisus: 0.025 },
	{ baseSize: 187, baseVisus: 0.032 },
	{ baseSize: 148, baseVisus: 0.04 },
	{ baseSize: 118, baseVisus: 0.05 },
	{ baseSize: 94, baseVisus: 0.063 },
	{ baseSize: 75, baseVisus: 0.08 },
	{ baseSize: 59, baseVisus: 0.1 },
	{ baseSize: 47, baseVisus: 0.12 },
	{ baseSize: 37, baseVisus: 0.16 },
	{ baseSize: 30, baseVisus: 0.2 },
	{ baseSize: 24, baseVisus: 0.25 },
	{ baseSize: 19, baseVisus: 0.32 },
	{ baseSize: 15, baseVisus: 0.4 },
	{ baseSize: 12, baseVisus: 0.5 },
	{ baseSize: 9.5, baseVisus: 0.63 },
	{ baseSize: 7.5, baseVisus: 0.8 },
	{ baseSize: 6, baseVisus: 1 },
	{ baseSize: 4.7, baseVisus: 1.25 },
	{ baseSize: 3.8, baseVisus: 1.6 },
	{ baseSize: 3, baseVisus: 2 }
];
